import {
  formattedDuration,
  type FormattedDurationOptions,
  MAX_MINUTES_TO_DISPLAY,
} from '@drycut/ui-format-utils';

type Props = {
  options?: FormattedDurationOptions;
  relativeTime: string;
  time: number;
};

export function WaitingTime({ time, relativeTime, options }: Props): React.ReactElement {
  return (
    <span data-time={time} data-estimate-start={relativeTime}>
      {time <= MAX_MINUTES_TO_DISPLAY * 60 ? formattedDuration(time, options) : relativeTime}
    </span>
  );
}
